import { SearchModal } from "@core-shop/components";
import { SearchModalView } from "./SearchModalView";

export const Search = () => {
  return <SearchModal View={SearchModalView} />;
};
